// Centralized API base URL configuration.
// IMPORTANT: do NOT hardcode REACT_APP_BACKEND_URL — always read from env.
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
